// extracted by mini-css-extract-plugin
export default {"selected":"d82ef42742","un":"b1dd6adc35"};